
import Coffee from "../../../assets/filled/Coffee.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CoffeeIcon({ className, dataTestid = "CoffeeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Coffee data-testid={dataTestid} className={classes} {...rest} />
  );
}
